import styled from 'styled-components';

const Steps = styled.div`
	display: flex;
	max-width: ${(props) => (props.small ? '720px' : '1125px')};
	width: ${(props) => (props.width ? props.width : '90%')};
	margin: auto;
	margin-top: 1.25rem;
	justify-content: space-between;
	@media (max-width: 1200px) {
		overflow-x: auto;
	}
`;

export default Steps;
